import api from '../../../services/api';

const API_URL = '/api/v1/employee/bidSelectionTemplate';

/**
 * @param {string} profileId
 * @param {EmployeeBidSelection.IEmployeePreferentialBidSelection} bidSelection
 * @returns {Promise<any>}
 */
export const saveBidSelectionTemplate = (profileId, bidSelection) => api.post(`${API_URL}/${profileId}/preferential`, bidSelection);

/**
 * @param {string} profileId
 * @returns {Promise<ApiEmployee.GetBidSelectionTemplateResponse>}
 */
export const loadBidSelectionTemplate = (profileId) => api.get(`${API_URL}/${profileId}`);

/**
 * @returns {Promise<ApiEmployee.GetAllBidSelectionTemplateResponse>}
 */
export const getAllBidSelectionTemplates = () => api.get(API_URL);
